var map = {
	"./Settings-cog.svg": [
		24582,
		4582
	],
	"./activity.svg": [
		70268,
		268
	],
	"./alert-f.svg": [
		21468,
		1468
	],
	"./arrow-circle-right-up.svg": [
		67642,
		7642
	],
	"./arrow-left.svg": [
		81396,
		1396
	],
	"./arrow-up-right.svg": [
		12704,
		2704
	],
	"./arrow_up_right.svg": [
		79924,
		9924
	],
	"./audience.svg": [
		70413,
		413
	],
	"./bell.svg": [
		21933,
		1933
	],
	"./bin.svg": [
		2897,
		2897
	],
	"./book.svg": [
		9081,
		9081
	],
	"./building.svg": [
		83291,
		3291
	],
	"./calendar-alt.svg": [
		2314,
		2314
	],
	"./calendar-f.svg": [
		83054,
		3054
	],
	"./calendar-filled.svg": [
		53595,
		3595
	],
	"./calendar.svg": [
		18666,
		8666
	],
	"./check.svg": [
		39271,
		9271
	],
	"./chevron-circle-left.svg": [
		31040,
		1040
	],
	"./chevron-down-thin.svg": [
		57792,
		7792
	],
	"./chevron-down.svg": [
		76257,
		6257
	],
	"./chevron-left.svg": [
		43086,
		3086
	],
	"./chevron-right.svg": [
		32204,
		2204
	],
	"./chevron-up.svg": [
		17953,
		7953
	],
	"./chevron_right.svg": [
		81946,
		7819
	],
	"./circle-f.svg": [
		27626,
		7626
	],
	"./clipboard-check.svg": [
		48563,
		8563
	],
	"./clipboard-filled.svg": [
		94976,
		4976
	],
	"./clipboard.svg": [
		76070,
		6070
	],
	"./clock.svg": [
		90347,
		347
	],
	"./close.svg": [
		98039,
		8039
	],
	"./cloud.svg": [
		22337,
		2337
	],
	"./cog.svg": [
		11623,
		1623
	],
	"./coin.svg": [
		94454,
		4454
	],
	"./document-f.svg": [
		97975,
		7975
	],
	"./document.svg": [
		80106,
		106
	],
	"./dollar.svg": [
		71984,
		1984
	],
	"./envelope.svg": [
		94057,
		1889
	],
	"./eye-close.svg": [
		86660,
		6660
	],
	"./eye.svg": [
		34278,
		4278
	],
	"./filter_list.svg": [
		66211,
		6211
	],
	"./frankie-arrow-right.svg": [
		18882,
		8882
	],
	"./frankie-bell.svg": [
		80024,
		24
	],
	"./frankie-billing.svg": [
		26609,
		6609
	],
	"./frankie-bin.svg": [
		89258,
		9258
	],
	"./frankie-bolt.svg": [
		59918,
		9918
	],
	"./frankie-calendar.svg": [
		22090,
		2090
	],
	"./frankie-card.svg": [
		26955,
		6955
	],
	"./frankie-care-icon.svg": [
		86106,
		6106
	],
	"./frankie-check.svg": [
		33226,
		3226
	],
	"./frankie-client.svg": [
		24874,
		4874
	],
	"./frankie-clients.svg": [
		98986,
		8986
	],
	"./frankie-cog.svg": [
		97820,
		7820
	],
	"./frankie-form.svg": [
		79819,
		9819
	],
	"./frankie-hamburger.svg": [
		34552,
		4552
	],
	"./frankie-home.svg": [
		22139,
		2139
	],
	"./frankie-info.svg": [
		98198,
		8198
	],
	"./frankie-mail.svg": [
		74510,
		4510
	],
	"./frankie-pin.svg": [
		97497,
		7497
	],
	"./frankie-refund.svg": [
		52102,
		2102
	],
	"./frankie-rocket.svg": [
		18863,
		8863
	],
	"./frankie-sales.svg": [
		41546,
		1546
	],
	"./frankie-team.svg": [
		77973,
		7973
	],
	"./frankie-video.svg": [
		34511,
		4511
	],
	"./home-f.svg": [
		93590,
		3590
	],
	"./home.svg": [
		58135,
		8135
	],
	"./icon-error.svg": [
		3366,
		3943
	],
	"./icon-warning.svg": [
		62642,
		7518
	],
	"./icon_add.svg": [
		72130,
		8767
	],
	"./icon_admin.svg": [
		75138,
		5138
	],
	"./icon_arrow_right.svg": [
		60746,
		746
	],
	"./icon_arrow_right_green.svg": [
		75252,
		5252
	],
	"./icon_blank_form.svg": [
		47842,
		7842
	],
	"./icon_bolt.svg": [
		8207,
		8207
	],
	"./icon_calendar.svg": [
		64578,
		4578
	],
	"./icon_calendar_empty_black.svg": [
		77094,
		7094
	],
	"./icon_calendar_empty_white.svg": [
		35023,
		5023
	],
	"./icon_chevron_down.svg": [
		74862,
		4862
	],
	"./icon_chevron_left.svg": [
		28110,
		8110
	],
	"./icon_chevron_right.svg": [
		16357,
		6357
	],
	"./icon_clock.svg": [
		75076,
		5076
	],
	"./icon_close.svg": [
		40852,
		852
	],
	"./icon_close_grey.svg": [
		83669,
		3669
	],
	"./icon_contact.svg": [
		62345,
		2345
	],
	"./icon_copy.svg": [
		12591,
		2591
	],
	"./icon_dashboard_calm.svg": [
		1972,
		1972
	],
	"./icon_dashboard_creativity.svg": [
		85194,
		5194
	],
	"./icon_dashboard_focus.svg": [
		30419,
		419
	],
	"./icon_down_chevron_grey.svg": [
		55803,
		5803
	],
	"./icon_down_chevron_white.svg": [
		87591,
		7591
	],
	"./icon_external_link.svg": [
		48643,
		8643
	],
	"./icon_first_aid_kit.svg": [
		35810,
		5810
	],
	"./icon_gear.svg": [
		18758,
		8758
	],
	"./icon_group.svg": [
		44821,
		4821
	],
	"./icon_header_calm.svg": [
		35184,
		5184
	],
	"./icon_header_creativity.svg": [
		8,
		8
	],
	"./icon_header_end.svg": [
		68895,
		8895
	],
	"./icon_header_focus.svg": [
		29387,
		9387
	],
	"./icon_header_home.svg": [
		94049,
		4049
	],
	"./icon_header_results.svg": [
		73036,
		3036
	],
	"./icon_header_settings.svg": [
		18389,
		8389
	],
	"./icon_header_sign_out.svg": [
		45840,
		5840
	],
	"./icon_headset.svg": [
		42768,
		2768
	],
	"./icon_help.svg": [
		56157,
		6157
	],
	"./icon_included.svg": [
		91858,
		1858
	],
	"./icon_info.svg": [
		25953,
		5953
	],
	"./icon_instruction_replay.svg": [
		43534,
		3534
	],
	"./icon_left_chevron.svg": [
		58436,
		2194
	],
	"./icon_list_black.svg": [
		32474,
		2474
	],
	"./icon_list_white.svg": [
		12533,
		2533
	],
	"./icon_loading.svg": [
		3469,
		3469
	],
	"./icon_lock.svg": [
		92636,
		2636
	],
	"./icon_login_facebook.svg": [
		3418,
		3418
	],
	"./icon_login_google.svg": [
		29942,
		9942
	],
	"./icon_logo_colour.svg": [
		50170,
		170
	],
	"./icon_logout.svg": [
		94659,
		4659
	],
	"./icon_mail.svg": [
		37562,
		7562
	],
	"./icon_menu.svg": [
		79241,
		9241
	],
	"./icon_microphone.svg": [
		7628,
		7628
	],
	"./icon_monitor.svg": [
		30045,
		45
	],
	"./icon_more.svg": [
		61189,
		8837
	],
	"./icon_my_profile.svg": [
		81377,
		1377
	],
	"./icon_open_apostrophe.svg": [
		60434,
		434
	],
	"./icon_pause.svg": [
		33764,
		3764
	],
	"./icon_play.svg": [
		17358,
		7358
	],
	"./icon_refresh.svg": [
		62834,
		2834
	],
	"./icon_repeat.svg": [
		22006,
		2006
	],
	"./icon_reward.svg": [
		30730,
		730
	],
	"./icon_right_chevron.svg": [
		96935,
		6935
	],
	"./icon_search.svg": [
		18553,
		8553
	],
	"./icon_secure_shield.svg": [
		58026,
		8026
	],
	"./icon_settings.svg": [
		46524,
		6524
	],
	"./icon_sparkle.svg": [
		56024,
		6024
	],
	"./icon_spinner.svg": [
		86067,
		6067
	],
	"./icon_stethoscope.svg": [
		49936,
		9936
	],
	"./icon_tag.svg": [
		63156,
		3156
	],
	"./icon_tick.svg": [
		95663,
		5663
	],
	"./icon_up_arrow_base.svg": [
		80661,
		661
	],
	"./icon_user.svg": [
		75218,
		5218
	],
	"./icon_user_add.svg": [
		737,
		737
	],
	"./icon_users.svg": [
		19295,
		9295
	],
	"./icon_view_account.svg": [
		80029,
		29
	],
	"./icon_view_appointments.svg": [
		50064,
		64
	],
	"./icon_view_patients.svg": [
		12423,
		2423
	],
	"./icon_view_payments.svg": [
		37790,
		7790
	],
	"./icon_warning.svg": [
		73511,
		3511
	],
	"./icon_white_tick.svg": [
		21515,
		1515
	],
	"./inbox.svg": [
		51163,
		1163
	],
	"./info.svg": [
		20388,
		388
	],
	"./lightning.svg": [
		17809,
		7809
	],
	"./logo.svg": [
		93594,
		3594
	],
	"./logo_google_long.svg": [
		96344,
		6344
	],
	"./logo_icon.svg": [
		88525,
		8525
	],
	"./menu-client.svg": [
		24705,
		4705
	],
	"./menu-notifications.svg": [
		99671,
		6117
	],
	"./menu-settings.svg": [
		95774,
		5774
	],
	"./menu-support.svg": [
		17795,
		7795
	],
	"./menu-team.svg": [
		30074,
		74
	],
	"./menu.svg": [
		34555,
		4555
	],
	"./more-horizontal-f.svg": [
		46253,
		6253
	],
	"./more-horizontal.svg": [
		63895,
		3895
	],
	"./mug.svg": [
		83448,
		3448
	],
	"./navbar-back-arrow.svg": [
		5744,
		5744
	],
	"./notification-form.svg": [
		20278,
		278
	],
	"./notification-new-client.svg": [
		89676,
		9676
	],
	"./payment-card.svg": [
		28998,
		3721
	],
	"./pencil.svg": [
		22702,
		2702
	],
	"./people.svg": [
		31467,
		1467
	],
	"./person.svg": [
		51932,
		1932
	],
	"./phone.svg": [
		54709,
		4709
	],
	"./pie-chart.svg": [
		69671,
		9671
	],
	"./plus.svg": [
		19213,
		9213
	],
	"./podcast.svg": [
		74140,
		4140
	],
	"./rainbow.svg": [
		11119,
		1119
	],
	"./redirect.svg": [
		95785,
		5785
	],
	"./rocket.svg": [
		82379,
		2379
	],
	"./shield.svg": [
		19192,
		9192
	],
	"./smile.svg": [
		87877,
		7877
	],
	"./squares.svg": [
		67243,
		7243
	],
	"./store.svg": [
		77917,
		7917
	],
	"./task-list.svg": [
		10499,
		499
	],
	"./thunder.svg": [
		79090,
		9090
	],
	"./trash.svg": [
		46168,
		6168
	],
	"./union.svg": [
		13303,
		3303
	],
	"./unmind-full-logo-dark.svg": [
		30931,
		931
	],
	"./unmind-full-logo-light.svg": [
		47803,
		7803
	],
	"./unmind-logo-dark.svg": [
		421,
		421
	],
	"./unmind-logo-light.svg": [
		63181,
		3181
	],
	"./unmind-mono-outline.svg": [
		345,
		345
	],
	"./upload-file.svg": [
		28159,
		8159
	],
	"./upload.svg": [
		88943,
		8943
	],
	"./user-circle.svg": [
		62792,
		2792
	],
	"./user-inverse.svg": [
		85918,
		5918
	],
	"./user-plus.svg": [
		83617,
		3617
	],
	"./user.svg": [
		10433,
		433
	],
	"./user_avatar_32x32.svg": [
		63909,
		3909
	],
	"./users.svg": [
		12907,
		2907
	],
	"./v2-bar-chart.svg": [
		71957,
		1957
	],
	"./v2-calendar.svg": [
		2130,
		2130
	],
	"./v2-close.svg": [
		64434,
		4434
	],
	"./v2-cog.svg": [
		5760,
		5760
	],
	"./v2-form.svg": [
		61255,
		1255
	],
	"./v2-group.svg": [
		93840,
		3840
	],
	"./v2-home.svg": [
		86248,
		6248
	],
	"./v2-integrations.svg": [
		10481,
		481
	],
	"./v2-key.svg": [
		26356,
		6356
	],
	"./v2-person.svg": [
		82668,
		2668
	],
	"./v2-pie-chart.svg": [
		34523,
		4523
	],
	"./v2-select-close.svg": [
		99471,
		9471
	],
	"./v2-share.svg": [
		23072,
		3072
	],
	"./v2-stack.svg": [
		36046,
		6046
	],
	"./v2-team.svg": [
		61998,
		1998
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 67852;
module.exports = webpackAsyncContext;